module.exports = __webpack_public_path__ + "static/media/synchronization.7db81399.svg";